var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 28,
    height: 28,
    rx: 6,
    fill: "none",
    stroke: "#40E0D0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18l4-4-4-4-12 4-4-2v4l4 2 12 4 4-4z",
    fill: "none",
    stroke: "#40E0D0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 14,
    r: 1,
    fill: "#40E0D0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.5203b4299293e0d8e9dc44d264e059a9.svg";
export { ForwardRef as ReactComponent };